export function displayValueToStep({
  displayValue,
  min,
  scale,
}: {
  displayValue: number;
  min: number;
  scale: number;
}) {
  return (displayValue - min) / scale;
}

export function stepToDisplayValue({
  step,
  min,
  scale,
}: {
  step: number;
  min: number;
  scale: number;
}) {
  return step * scale + min;
}
